import { isPointedToProd } from "./point-to-prod";

export function getMosaicLocation() {
  const host = isPointedToProd()
    ? "jigsaw.vitalsource.com"
    : process.env.REACT_APP_MOSAIC_HOST;
  return `//${host}${process.env.REACT_APP_MOSAIC_PATH}/mosaic.js`;
}
